import React, { Component } from 'react';
import { styled } from '@compiled/react';
import { formatISO } from 'date-fns';
import { DatePicker } from '@atlaskit/datetime-picker';
import { Field } from '@atlaskit/form';
import { token } from '@atlaskit/tokens';
import dateMessages from '@atlassian/jira-common-date/src/utils/date-messages/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import SuppressEscKey from '../../../../common/components/suppress-esc-key/SuppressEscKey.tsx';
import type { DateFormat } from '../../../../common/model/index.tsx';
import type { ReleaseVersionValidationErrors, ReleasableVersion } from '../../../model/index.tsx';
import messages from './messages.tsx';

export type Props = {
	readonly isSaving: boolean;
	readonly releaseDate: DateFormat;
	readonly errors: ReleaseVersionValidationErrors;
	readonly onInputChange: (arg1: Partial<ReleasableVersion>) => void;
	readonly intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
export class ReleaseDatePicker extends Component<Props> {
	onReleaseDateChange = (releaseDate: DateFormat): void => {
		if (releaseDate) {
			this.inputChange({ releaseDate });
		} else {
			this.inputChange({ releaseDate: '' });
		}
	};

	inputChange(update: Partial<ReleasableVersion>): void {
		const { onInputChange } = this.props;

		onInputChange({ releaseDate: update.releaseDate });
	}

	render(): React.JSX.Element {
		const {
			intl: { formatMessage, locale },
			releaseDate,
			errors,
			isSaving,
		} = this.props;
		const { releaseDate: releaseDateError } = errors;

		return (
			<>
				<Field
					id={formatMessage(messages.releaseDate)}
					name="releaseDate"
					label={formatMessage(messages.releaseDate)}
				>
					{() => (
						<DatePickerContainer>
							<SuppressEscKey>
								<DatePicker
									id={formatMessage(messages.releaseDate)}
									isDisabled={isSaving}
									defaultValue={releaseDate !== '' ? formatISO(new Date(releaseDate)) : releaseDate}
									onChange={this.onReleaseDateChange}
									placeholder={formatMessage(dateMessages.placeholderDate)}
									locale={locale}
									shouldShowCalendarButton
								/>
							</SuppressEscKey>
						</DatePickerContainer>
					)}
				</Field>
				{releaseDateError && <ValidationError>{releaseDateError}</ValidationError>}
			</>
		);
	}
}

export default injectIntl(ReleaseDatePicker);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DatePickerContainer = styled.div({
	width: '50%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ValidationError = styled.div({
	marginTop: token('space.100'),

	color: token('color.text.danger'),
});
